import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NzMessageService, NzModalService } from 'ng-zorro-antd';
import { KnowledgebaseSettingService } from 'src/app/shared/services/knowledgebase-setting.service';

@Component({
  selector: 'app-knowledgebase-setting',
  templateUrl: './knowledgebase-setting.component.html',
  styleUrls: ['./knowledgebase-setting.component.css']
})
export class KnowledgebaseSettingComponent implements OnInit {

   displayData: any[] = [];
  regionLoading = false;
  

  constructor(private knowledgeBaseService: KnowledgebaseSettingService,
     private messageService: NzMessageService,
     private router : Router,
     private modalService: NzModalService
  ) { }

  ngOnInit() {
 this.fetchAiSettingList();
  }
  // fetchRegionList() { 
  //   this.msgService.remove();
  //   this.regionLoading = true;
  //  // var msgId = this.msgService.loading("Loading...",{ nzDuration: 0 }).messageId;
  //   this.regionService.regionList().subscribe((res) => {
  //     this.regionLoading = false;
  //     //this.msgService.remove(msgId);
  //     this.RegionList = res.body;
  //     this.displayData = this.RegionList;
  //   }
  //   );   
  // }
 fetchAiSettingList() {
    this.regionLoading = true;
    this.knowledgeBaseService.aiSettingList().subscribe((res: any) => {
      this.displayData = res.body || res;  // Adjust based on actual response
      this.regionLoading = false;

      this.displayData.forEach(item => {
        if (item.lastRunDate) {
          item.lastRunDate = new Date(item.lastRunDate + 'Z');
        }
        if (item.nextRunDate) {
          item.nextRunDate = new Date(item.nextRunDate + 'Z');
        }
      });
    }, error => {
      this.regionLoading = false;
      console.error("Error fetching AI settings", error);
    });
  }

  deleteAiSettingById(id) {
    var msgId = this.messageService.loading("Deleting...", { nzDuration: 0 }).messageId;
    this.knowledgeBaseService.deleteById(id).subscribe((res) => {
      setTimeout(() => {
        this.messageService.remove(msgId);
        this.fetchAiSettingList();
      }, 1000);
    })
  }
  showDeleteConfirm(id): void {
    this.modalService.confirm({
      nzTitle: 'Delete this Bot ?',
      nzOkText: 'Yes',
      nzOkType: 'danger',
      nzOnOk: () => this.deleteAiSettingById(id),
      nzCancelText: 'No'
    });
  }

  openEditPage(id: any){   
    this.router.navigate([`setting/${id}`])
  }

}


